if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();

      this.images = Array.from(
        this.querySelectorAll('[data-images] img, [data-images] svg'),
      );
      this.swatches = this.querySelector('[data-swatches]');
      this.price = this.querySelector('[data-price]');
      this.productLinks = this.querySelectorAll('[data-product-link]');
      this.prices = JSON.parse(
        this.querySelector('[data-variants-prices]').textContent,
      );

      this.swatches?.addEventListener('change', (e) => {
        this.updateImage(e.target.dataset.variantId);
        this.updatePrice(e.target.dataset.variantId);
        this.updateLinks(e.target.dataset.variantUrl);
      });
    }

    updateLinks(url) {
      this.productLinks.forEach((link) => (link.href = url));
    }

    updatePrice(variantId) {
      const price = this.prices.find((priceObj) => priceObj.id == variantId);

      console.log(price.price_html);
      console.log(this.price);
      this.price.innerHTML = price.price_html;
    }

    updateImage(variantId) {
      if (this.images.length === 0) return;

      const visibleImage = this.querySelector('[data-images] img:not(.hidden)');
      let newVisibleImage = this.images.find(
        (image) => image.dataset.variantId === variantId,
      );
      if (!newVisibleImage) newVisibleImage = this.images[0];

      visibleImage.classList.add('hidden');
      newVisibleImage.classList.remove('hidden');
    }
  }

  customElements.define('card-product', CardProduct);
}
